module.exports = __webpack_public_path__ + "static/14-82a36535f45b5172fe5e0c7c1afb3faf.jpg";